<template>
    <div>
        <div v-if="config.modules.wishlist">
            <div class="btn btn-link" @click="toggleToWishlist">
                <span v-if="this.wishlist.find((prod) => prod.id == this.product.id)">
                    <i class="fa-solid fa-bookmark"></i> {{t.wishlist.remove_from_wishlist}}
                </span>
                <span v-else>
                    <i class="fa-regular fa-bookmark"></i> {{t.wishlist.add_to_wishlist}}
                </span>
            </div>
        </div>
        <div class="d-flex mt-3">
            <div class="me-3">
                <div class="mb-3 mb-lg-0">
                    <a v-if="dataProduct.variations.length" :href="dataProduct.url" class="btn btn-primary"><span>{{ t.product.select_options }}</span></a>
                    <button v-if="!dataProduct.variations.length" class="btn btn-primary" @click="addToCart"
                        :disabled="!canOrder">{{ t.product.add_to_cart }}</button>
                </div>
            </div>
            <div v-if="config.modules.buy_now && canOrder">
                <div>
                    <a class="btn btn-secondary" @click="buyNow">{{
                            t.product.buy_now}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../CartStore";
export default {
    props: ['dataProduct'],
    store: store,
    data() {
        return {
            t: t,
            config: config,
            wishlist: config.modules.wishlist ? wishlist : [],
            product: this.dataProduct
        };
    },
    computed: {
        canOrder() {
            return true
        },
    },
    methods: {
        ...Vuex.mapActions(['addProduct']),
        buyNow() {
            axios.get('/ajax/disable-popup').then(() => {
                window.location.href = this.product.buyNow
            });
        },
        addToCart() {
            var productToAddToCart = this.product
            this.addProduct(productToAddToCart);
        },
        toggleToWishlist() {
            axios
            .post("/ajax/wishlist/toggleToWishlist", {
                id: this.product.id
            })
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response) => {
                Vue.notify({text: response.data.message.text, type: response.data.message.type})
                this.wishlist = response.data.wishlist
                this.$root.$emit("updateWishlist", response.data.wishlist);
            });
        },
        disablePopup() {
            axios.get('/ajax/disable-popup').then(() => {
                $('#popup').modal('hide')
            });
        },
    },
}
</script>
